module.exports = __webpack_public_path__ + "static/media/videoBG.c6f06064.mp4";